import { setPostRegisterHook } from '../stores/device'
import { createOutboxStore } from './idbStore'
import { createOutbox, type EnqueueInput, type Outbox } from './outbox'

export type { OutboxItem, OutboxKind, OutboxStore } from './types'
export { createOutbox, type Outbox, type OutboxStats } from './outbox'
export { createMemoryStore } from './memoryStore'

/**
 * The app's single outbox, and its triggers — offline-sync.md §4.
 */

let instance: Outbox | null = null
let started = false

export function outbox(): Outbox {
  instance ??= createOutbox({ store: createOutboxStore() })
  return instance
}

/** Queue a write. Returns immediately — gameplay never awaits the network. */
export function enqueue(input: EnqueueInput): void {
  outbox().enqueue(input)
}

/**
 * Wires the three event-driven triggers and the §4.5 hand-off. Idempotent.
 *
 * The fourth trigger — the 30 s periodic timer — lives inside the outbox itself,
 * because it must run **only while items remain**.
 */
export function startOutbox(): void {
  if (started || typeof window === 'undefined') return
  started = true

  const flush = (): void => {
    void outbox().flush()
  }

  // Connectivity returned.
  window.addEventListener('online', flush)
  /*
   * Tab regained — *"covers laptop-lid-close, the classroom norm"*. A shared
   * laptop spends its day being shut and reopened between groups, and that is a
   * focus event rather than an online one.
   */
  window.addEventListener('focus', flush)

  /*
   * 🔴 REGISTER, **THEN** DRAIN (offline-sync.md §8).
   *
   * The common case this exists for: the device was used offline yesterday and
   * is back on the school network now. Its queue cannot flush until there is a
   * token to flush with, so the drain hangs off registration rather than off
   * boot.
   */
  setPostRegisterHook(flush)
}
